import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34b9d043"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "fv-row" }
const _hoisted_3 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_4 = { class: "fv-row" }
const _hoisted_5 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_6 = { class: "fv-row" }
const _hoisted_7 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_8 = { class: "required fw-bold fs-6" }
const _hoisted_9 = { class: "text-gray-800 fs-6" }
const _hoisted_10 = { class: "text-center pt-15" }
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = { class: "indicator-progress" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModalLayout = _resolveComponent("ModalLayout")!

  return (_openBlock(), _createBlock(_component_ModalLayout, {
    "max-width": "700px",
    title: _ctx.$t('addUser')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "form form-add-user",
        model: _ctx.targetData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("firstName")), 1),
              _createVNode(_component_el_form_item, { prop: "firstName" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    name: "firstName",
                    modelValue: _ctx.targetData.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.firstName) = $event)),
                    class: "form-control form-control-solid mb-3 mb-lg-0",
                    placeholder: "First Name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("lastName")), 1),
              _createVNode(_component_el_form_item, { prop: "lastName" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    name: "lastName",
                    class: "form-control form-control-solid mb-3 mb-lg-0",
                    placeholder: "Last Name",
                    modelValue: _ctx.targetData.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.lastName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("email")), 1),
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "email",
                    name: "email",
                    class: "form-control form-control-solid mb-3 mb-lg-0",
                    placeholder: "example@domain.com",
                    modelValue: _ctx.targetData.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("role")), 1),
              _createVNode(_component_el_form_item, { prop: "groups" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.targetData.groups,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.groups) = $event)),
                    class: "d-flex justify-content-start flex-wrap"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          label: item.id,
                          key: index,
                          name: "groups"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetForm(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("discard")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("submit")), 1),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + "... ", 1),
                  _hoisted_13
                ])
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title"]))
}